import { createI18n } from 'vue-i18n';
// app locales
import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import it from './locales/it.json';

// DeepUiLib locales
import { locales } from '@deepcloud/deep-ui-lib';
import { useStorage } from '@vueuse/core';

const storedAppLocale = useStorage('storedAppLocale', '');

// `createI18n` options is almost same vue-i18n-next (vue-i18n@v9.x) API
const i18n = createI18n({
  legacy: false,
  locale: storedAppLocale.value || import.meta.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  silentTranslationWarn: false,
  warnHtmlMessage: true,
  globalInjection: false,
  // locale files are kept flat (dot separated keys) so they can be managed by Weblate
  flatJson: true,
  messages: {
    de,
    en,
    fr,
    it
  }
});

i18n.global.mergeLocaleMessage('de', locales.de);
i18n.global.mergeLocaleMessage('fr', locales.fr);
i18n.global.mergeLocaleMessage('it', locales.it);
i18n.global.mergeLocaleMessage('en', locales.en);

export default i18n;
